import {clearQusetionsSessionStorage} from '../helpers/helper-functions';
import {FirestoreUser} from '../firebase-listeners/interface';
import {setFirestoreUser} from './firestore';
import {auth, UserInfo} from 'firebase/app';
import {getFirestoreUser} from "../firebase-listeners/firestore-user";

export function doSignOut(): Promise<void> {
	return signOut();
}

export function signOut(): Promise<void> {
	return auth().signOut().then(() => {
		sessionStorage.setItem("userId", "");
		sessionStorage.setItem("userFirstName", "");
		sessionStorage.setItem("userLoggedIn", "false");
		clearQusetionsSessionStorage();
	});
}

export async function signInWithEmailAndPassword(req: {email: string, password: string}): Promise<FirestoreUser> {
	const userCredential = await auth().signInWithEmailAndPassword(req.email, req.password);
	return doSignInJobWithCurrentUser(userCredential.user);
}

export async function doSignInJobWithCurrentUser(authUser: UserInfo | null): Promise<FirestoreUser> {
	const userId = authUser?.uid || '';
	sessionStorage.setItem("userLoggedIn", "true");
	sessionStorage.setItem("userId", userId);

	const user = await getFirestoreUser(userId, true);
	sessionStorage.setItem("userFirstName", user?.firstname);
	return user;
}

export async function createUserWithEmailAndPassword(req: {email: string, password: string, user: Partial<FirestoreUser>}): Promise<Partial<FirestoreUser>> {
	const userCredential = await auth().createUserWithEmailAndPassword(req.email, req.password);
	return setFirestoreUser(userCredential?.user?.uid || '', {
		...req.user,
		uid: userCredential?.user?.uid,
		email: req?.user?.email || userCredential?.user?.email || '',
	});
}

export async function getCurrentUserId(): Promise<string | undefined> {
	return  sessionStorage.getItem('userId') || (await getCurrentAuthUser())?.uid
}

export async function getCurrentAuthUser(): Promise<UserInfo | null> {
	const remember = localStorage.getItem(`reqmaster-remember-me`) === 'true';
	let user: UserInfo | null =  auth().currentUser;
	user = user ?? await tryGettingAuthUser(100);
	if (remember) {
		user = user ?? await tryGettingAuthUser(100) ??
			await tryGettingAuthUser(250) ??
			await tryGettingAuthUser(500) ??
			await tryGettingAuthUser(1000);
	}
	return user;
}

function tryGettingAuthUser(delay: number): Promise<UserInfo | null> {
	return sleep(delay).then(() => getCurrentAuthUser())
}

function sleep(ms: number) {
	return new Promise((resolve,) => setTimeout(resolve, ms));
}
